import { TranslationProvider } from '@frontend/lang';
import { SentryErrorBoundary, initSentry } from '@frontend/sentry';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import App from './app/app';
import { store } from './app/redux/store';
import './app/utils/external-navigation-handler';
import { registerServiceWorker } from './serviceWorkerRegistration';
import './styles.css';

initSentry('mobile');

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <StrictMode>
        <TranslationProvider>
            <SentryErrorBoundary>
                <Provider store={store}>
                    <App />
                </Provider>
            </SentryErrorBoundary>
        </TranslationProvider>
    </StrictMode>
);

registerServiceWorker();
